// GOB Club Membership — product page, quick add modal & real-time pricing
(function() {
  var MEMBERSHIP_VARIANT_ID = 53631345131853;
  var MEMBERSHIP_SELLING_PLAN_ID = 692298416461;
  var MEMBER_TAG = 'gob_club_member';
  var DISCOUNT = 0.30;
  var gobHandling = false;
  var currentPriceCents = null;

  function isMember() {
    var metaEl = document.querySelector('meta[name="customer-tags"]');
    if (metaEl) return metaEl.content.indexOf(MEMBER_TAG) !== -1;
    return false;
  }

  function isMemberAsync() {
    // Use cart attribute approach — set a known attribute and check customer state
    // Falls back to checking window.__st (Shopify tracking object) for customer info
    return fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      // Check Shopify's global customer object if available
      if (window.__st && window.__st.cid) {
        // Customer is logged in — check meta tag one more time after slight delay
        var metaEl = document.querySelector('meta[name="customer-tags"]');
        if (metaEl) return metaEl.content.indexOf(MEMBER_TAG) !== -1;
      }
      // Check if customer tags meta appeared after page settled
      var metaEl = document.querySelector('meta[name="customer-tags"]');
      if (metaEl && metaEl.content) {
        return metaEl.content.indexOf(MEMBER_TAG) !== -1;
      }
      return false;
    })
    .catch(function() { return false; });
  }

  function formatMoney(cents) {
    var formatted;
    if (window.theme && theme.Currency && theme.settings) {
      formatted = theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    } else {
      return (cents / 100).toFixed(2);
    }
    // Apply superscript to decimal cents if setting is enabled and not already done
    if (theme.settings.superScriptPrice && formatted.indexOf('<sup>') === -1) {
      var sep = formatted.indexOf(',') !== -1 && theme.settings.moneyFormat && theme.settings.moneyFormat.indexOf('amount_with_comma') !== -1 ? ',' : '.';
      if (formatted.indexOf(sep) !== -1) {
        formatted = formatted.replace(sep, '<sup>') + '</sup>';
      }
    }
    return formatted;
  }

  function memberPrice(cents) {
    return Math.round(cents * (1 - DISCOUNT));
  }

  function readVariantFromDOM(container) {
    var scriptTag = container.querySelector('script[data-product-json]');
    if (scriptTag) {
      try {
        var data = JSON.parse(scriptTag.textContent);
        var select = container.querySelector('[data-product-select]');
        if (select) {
          var variantId = parseInt(select.value);
          var variant = data.variants.find(function(v) { return v.id === variantId; });
          if (variant) return variant;
        }
        return { price: data.price, compare_at_price: null };
      } catch(e) {}
    }
    return null;
  }

  function readPriceFromDOM(container) {
    var variant = readVariantFromDOM(container);
    return variant ? variant.price : currentPriceCents;
  }

  function updateAllPrices(container, widget, priceCents, selectedOption, compareAtCents) {
    if (!priceCents) return;
    var discounted = memberPrice(priceCents);
    var formattedFull = formatMoney(priceCents);
    var formattedDiscounted = formatMoney(discounted);

    // 1. Big price [data-product-price]
    var bigPrice = container.querySelector('[data-product-price]');
    if (bigPrice) {
      bigPrice.innerHTML = selectedOption === 'member' ? formattedDiscounted : formattedFull;
    }

    // 2. Save amount [data-save-price]
    var saveEl = container.querySelector('[data-save-price]');
    if (saveEl) {
      if (selectedOption === 'member' && compareAtCents && compareAtCents > discounted) {
        // Show saving from compare-at to member price
        var memberSaving;
        if (theme.settings && theme.settings.saveType === 'percent') {
          memberSaving = Math.round(((compareAtCents - discounted) * 100) / compareAtCents) + '%';
        } else {
          memberSaving = formatMoney(compareAtCents - discounted);
        }
        saveEl.innerHTML = theme.strings && theme.strings.savePrice
          ? theme.strings.savePrice.replace('[saved_amount]', memberSaving)
          : 'Save ' + memberSaving;
        saveEl.classList.remove('hide');
      } else if (selectedOption !== 'member' && compareAtCents && compareAtCents > priceCents) {
        // Restore original saving
        var standardSaving;
        if (theme.settings && theme.settings.saveType === 'percent') {
          standardSaving = Math.round(((compareAtCents - priceCents) * 100) / compareAtCents) + '%';
        } else {
          standardSaving = formatMoney(compareAtCents - priceCents);
        }
        saveEl.innerHTML = theme.strings && theme.strings.savePrice
          ? theme.strings.savePrice.replace('[saved_amount]', standardSaving)
          : 'Save ' + standardSaving;
        saveEl.classList.remove('hide');
      } else if (selectedOption !== 'member') {
        saveEl.classList.add('hide');
      }
    }

    // 3. Standard option price inside widget
    var standardPrice = widget.querySelector('[data-standard-price]');
    if (standardPrice) standardPrice.innerHTML = formattedFull;

    // 4. Member option prices inside widget
    widget.querySelectorAll('[data-option="member"] .gob-membership-pricing__price--original').forEach(function(el) {
      el.innerHTML = formattedFull;
    });
    widget.querySelectorAll('[data-option="member"] .gob-membership-pricing__price--discounted').forEach(function(el) {
      el.innerHTML = formattedDiscounted;
    });

    // 5. Logged-in member block prices
    var memberOriginal = widget.querySelector('.gob-membership-pricing__member-prices .gob-membership-pricing__price--original');
    var memberDiscounted = widget.querySelector('.gob-membership-pricing__member-prices .gob-membership-pricing__price--discounted');
    if (memberOriginal) memberOriginal.innerHTML = formattedFull;
    if (memberDiscounted) memberDiscounted.innerHTML = formattedDiscounted;

    // 6. Guest member summary prices
    var guestOriginal = widget.querySelector('[data-guest-original]');
    var guestDiscounted = widget.querySelector('[data-guest-discounted]');
    if (guestOriginal) guestOriginal.innerHTML = formattedFull;
    if (guestDiscounted) guestDiscounted.innerHTML = formattedDiscounted;

    // 7. Save badge — show actual saving in current currency (floored, no cents)
    var saveBadge = widget.querySelector('[data-member-save-badge]');
    if (saveBadge) {
      var saving = priceCents - discounted;
      var flooredSaving = Math.floor(saving / 100) * 100;
      var formattedSaving = formatMoney(flooredSaving)
        .replace(/<sup>00<\/sup>/, '')  // remove superscript 00
        .replace(/\.00([^0-9]|$)/, '$1')  // remove .00
        .replace(/,00([^0-9]|$)/, '$1');  // remove ,00 (European)
      saveBadge.innerHTML = 'SAVE ' + formattedSaving;
    }
  }

  function getSelectedOption(widget) {
    var active = widget.querySelector('[data-option].is-selected');
    return active ? active.dataset.option : 'standard';
  }

  function hidePriceBlock(container) {
    var block = container.querySelector('.product-block--price');
    if (block) block.classList.add('gob-price-hidden');
  }

  function showPriceBlock(container) {
    var block = container.querySelector('.product-block--price');
    if (block) block.classList.remove('gob-price-hidden');
  }

  function initMemberPriceUpdates(container) {
    // For logged-in members — hide native price block, update prices on variant change
    var widget = container.querySelector('[data-membership-pricing]');
    if (!widget) return;

    hidePriceBlock(container);

    var productSection = container.querySelector('.product-section') || container;
    productSection.addEventListener('variantPriceChange', function(e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;

      var priceCents = variant.price;
      var discounted = memberPrice(priceCents);

      var originalEl = widget.querySelector('.gob-membership-pricing__price--original');
      var discountedEl = widget.querySelector('.gob-membership-pricing__price--discounted');
      if (originalEl) originalEl.innerHTML = formatMoney(priceCents);
      if (discountedEl) discountedEl.innerHTML = formatMoney(discounted);
    });
  }

  function updateAddToCartBtn(container, widget, priceCents) {
    var btn = container.querySelector('[data-add-to-cart]');
    var textEl = btn ? btn.querySelector('[data-add-to-cart-text]') : null;
    if (!textEl) return;
    // Store original text if not already stored
    if (!btn.dataset.originalText) {
      btn.dataset.originalText = textEl.textContent;
    }
    // Calculate saving
    var saving = priceCents - memberPrice(priceCents);
    var flooredSaving = Math.floor(saving / 100) * 100;
    var formattedSaving = formatMoney(flooredSaving)
      .replace(/<sup>00<\/sup>/, '')
      .replace(/\.00([^0-9]|$)/, '$1')
      .replace(/,00([^0-9]|$)/, '$1');
    textEl.textContent = 'Join & Add to cart — Save ' + formattedSaving;
  }

  function resetAddToCartBtn(container) {
    var btn = container.querySelector('[data-add-to-cart]');
    var textEl = btn ? btn.querySelector('[data-add-to-cart-text]') : null;
    if (!textEl || !btn.dataset.originalText) return;
    textEl.textContent = btn.dataset.originalText;
  }

  function initGobForm(container) {
    if (isMember()) {
      initMemberPriceUpdates(container);
      return;
    }

    var widget = container.querySelector('[data-membership-pricing]');
    if (!widget) return;

    var options = widget.querySelectorAll('[data-option]');

    // Listen for theme's variant price change
    var productSection = container.querySelector('.product-section') || container;
    var currentCompareAt = null;
    productSection.addEventListener('variantPriceChange', function(e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;
      currentPriceCents = variant.price;
      currentCompareAt = variant.compare_at_price || null;
      var selected = getSelectedOption(widget);
      updateAllPrices(container, widget, currentPriceCents, selected, currentCompareAt);
      // Keep price block hidden/shown based on current selection
      var summary = widget.querySelector('.gob-membership-pricing__guest-member-summary');
      if (selected === 'member') {
        hidePriceBlock(container);
        if (summary) summary.classList.remove('gob-summary-hidden');
        updateAddToCartBtn(container, widget, currentPriceCents);
      } else {
        showPriceBlock(container);
        if (summary) summary.classList.add('gob-summary-hidden');
        resetAddToCartBtn(container);
      }
    });

    // Option click
    options.forEach(function(option) {
      option.addEventListener('click', function() {
        options.forEach(function(o) { o.classList.remove('is-selected'); });
        option.classList.add('is-selected');
        var domVariant = readVariantFromDOM(container);
        var price = (domVariant ? domVariant.price : null) || currentPriceCents;
        var compareAt = (domVariant ? domVariant.compare_at_price : null) || currentCompareAt;
        if (price) updateAllPrices(container, widget, price, option.dataset.option, compareAt);

        var summary = widget.querySelector('.gob-membership-pricing__guest-member-summary');
        if (option.dataset.option === 'member') {
          hidePriceBlock(container);
          if (summary) summary.classList.remove('gob-summary-hidden');
          updateAddToCartBtn(container, widget, price);
        } else {
          showPriceBlock(container);
          if (summary) summary.classList.add('gob-summary-hidden');
          resetAddToCartBtn(container);
        }
      });
    });

    // Form submit
    var form = container.querySelector('.product-single__form');
    if (!form) return;
    if (form.dataset.gobInit) return;
    form.dataset.gobInit = '1';

    form.addEventListener('submit', function(e) {
      if (gobHandling) return;

      var selectedOption = widget.querySelector('[data-option].is-selected');
      if (!selectedOption || selectedOption.dataset.option !== 'member') return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var variantSelect = form.querySelector('[data-product-select]');
      var variantInput = form.querySelector('input[name="id"]');
      var variantId = variantSelect ? variantSelect.value : (variantInput ? variantInput.value : null);
      if (!variantId) return;

      var qtyInput = form.querySelector('input[name="quantity"]');
      var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      var btn = form.querySelector('[data-add-to-cart]');
      var textEl = btn ? btn.querySelector('[data-add-to-cart-text]') : null;
      var originalText = textEl ? textEl.textContent : '';
      if (btn) btn.disabled = true;
      if (textEl) textEl.textContent = 'Adding...';

      fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var alreadyInCart = cart.items.some(function(item) {
          return item.variant_id === MEMBERSHIP_VARIANT_ID;
        });
        if (alreadyInCart) return Promise.resolve();
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: MEMBERSHIP_VARIANT_ID,
            quantity: 1,
            selling_plan: MEMBERSHIP_SELLING_PLAN_ID
          })
        })
        .then(function(res) {
          if (!res.ok) return res.json().then(function(d) { throw new Error(d.description || 'Failed'); });
          return res.json();
        });
      })
      .then(function() {
        gobHandling = true;
        if (btn) btn.disabled = false;
        if (textEl) textEl.textContent = originalText;
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        gobHandling = false;
      })
      .catch(function(err) {
        console.error('GOB membership error:', err);
        if (btn) btn.disabled = false;
        if (textEl) textEl.textContent = originalText;
      });

    }, true);
  }

  // ── Enforce membership quantity = 1 always ───────────────
  function enforceMembershipQty() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var membershipItem = cart.items.find(function(item) {
        return item.variant_id === MEMBERSHIP_VARIANT_ID;
      });
      if (!membershipItem || membershipItem.quantity === 1) return;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: membershipItem.key, quantity: 1 })
      })
      .then(function() {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
    })
    .catch(function() {});
  }

  // ── Auto-remove membership from cart for logged-in members ──
  function removeMembershipFromCart() {
    // Check meta tag first
    if (isMember()) {
      doRemoveMembershipFromCart();
      return;
    }
    // If meta tag not available, check via /cart.js customer token
    // then re-check meta tag after a short delay (post-login page settle)
    setTimeout(function() {
      if (isMember()) doRemoveMembershipFromCart();
    }, 1000);
  }

  function doRemoveMembershipFromCart() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var membershipItem = cart.items.find(function(item) {
        return item.variant_id === MEMBERSHIP_VARIANT_ID;
      });
      if (!membershipItem) return;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: membershipItem.key, quantity: 0 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        window.location.reload();
      });
    })
    .catch(function() {});
  }

  window.addEventListener('load', function() {
    setTimeout(function() {
      removeMembershipFromCart();
      enforceMembershipQty();
      cleanInsuranceWarrantyIfMembershipOnly();
      initGobForm(document);
      // Init membership info modal on product page
      if (window.theme && theme.Modals && document.querySelector('#gob-membership-info')) {
        new theme.Modals('gob-membership-info', 'gob-membership-info');
      }
    }, 200);
  });

  // ── Remove insurance/warranty when membership is only item ─
  function cleanInsuranceWarrantyIfMembershipOnly() {
    var insuranceId = window.themeSettings && Number(window.themeSettings.shipping_insurance_product_id);
    var warrantyId = window.themeSettings && Number(window.themeSettings.extended_warranty_product_id);

    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var ADDON_IDS = [insuranceId, warrantyId].filter(Boolean);

      // Check if only membership + addons in cart (no real products)
      var hasRealItems = cart.items.some(function(item) {
        return item.variant_id !== MEMBERSHIP_VARIANT_ID && ADDON_IDS.indexOf(item.variant_id) === -1;
      });

      if (hasRealItems) return; // real products present — leave insurance/warranty alone

      // Remove any insurance/warranty items
      var removePromises = cart.items
        .filter(function(item) { return ADDON_IDS.indexOf(item.variant_id) !== -1; })
        .map(function(item) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        });

      if (removePromises.length === 0) return;

      Promise.all(removePromises).then(function() {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new Event('cart:build'));
      });
    })
    .catch(function() {});
  }

  // ── Membership remove handler ─────────────────────────────
  function initMembershipRemoveBtn() {
    document.querySelectorAll('.gob-membership-remove').forEach(function(link) {
      if (link.dataset.gobInit) return;
      link.dataset.gobInit = '1';
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var key = link.dataset.key;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          // Trigger full cart rebuild — removes discount note, refreshes prices
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new Event('cart:build'));
        })
        .catch(function() {});
      });
    });
  }

  // Run on load and whenever cart drawer updates
  window.addEventListener('load', function() {
    setTimeout(initMembershipRemoveBtn, 300);
  });
  document.addEventListener('cart:updated', function() {
    setTimeout(initMembershipRemoveBtn, 300);
    setTimeout(cleanInsuranceWarrantyIfMembershipOnly, 500);
  });
  document.addEventListener('ajaxProduct:added', function() {
    setTimeout(cleanInsuranceWarrantyIfMembershipOnly, 500);
  });
  document.addEventListener('CartDrawer:open', function() {
    cleanInsuranceWarrantyIfMembershipOnly();
  });

  document.addEventListener('quickadd:loaded', function() {
    setTimeout(function() {
      var holder = document.querySelector('#QuickAddHolder');
      if (holder) {
        initGobForm(holder);
        // Init the membership info modal if it was injected into the modal
        if (window.theme && theme.Modals && holder.querySelector('#gob-membership-info')) {
          new theme.Modals('gob-membership-info', 'gob-membership-info');
          // Stop close button bubbling up to the parent quick add modal
          var infoModal = document.querySelector('#gob-membership-info');
          if (infoModal) {
            infoModal.querySelectorAll('.js-modal-close').forEach(function(btn) {
              btn.addEventListener('click', function(e) {
                e.stopPropagation();
              });
            });
          }
        }
      }
    }, 200);
  });

})();